import contestGames from '@/api/services/contestGames'
import contestGamesParticipants from '@/api/services/contestGames/participants'

import type { ApiResponse, GameContest, Participant } from '@/types'

export default {
  contestGames,
  contestGamesParticipants,
}

export type ParticipantParams = {
  phoneNumber: string
  country: string
  email: string
  firstName: string
  hasOptin: boolean
  origin: string
}

export type ClientApi = {
  contestGames: {
    read: (id: string, storeSlug: string) => Promise<ApiResponse<GameContest>>
    readByPublicId: (id: string) => Promise<ApiResponse<GameContest>>
  }
  contestGamesParticipants: {
    create: (
      id: string,
      storeSlug: string,
      params: ParticipantParams,
    ) => Promise<ApiResponse<Participant>>
  }
}
